import * as React from 'react'

import { Box, Text, useToggle } from '@factorialco/deprecated-design-system'

import type ReportStruct from 'modules/reports/lib/ReportStruct'
import type { ReportEditorStore } from 'modules/reports/lib/Store'
import dashboards from 'modules/reports/store/collections/dashboards'

import AssignDashboardModal from './AssignDashboardModal'
import { OptionsButton } from './OptionsButton'

type AssignDashboardModalProps = React.ComponentProps<typeof AssignDashboardModal>

interface Props {
  reportStruct: ReportStruct
  onSaveTemplate: AssignDashboardModalProps['onSave']
  store: ReportEditorStore
  loading: boolean
}

export function Header({ reportStruct, onSaveTemplate, store, loading }: Props) {
  const [isAssignOpen, setIsAssign] = useToggle(false)

  const onAddTemplate = () => {
    if (dashboards.models.length > 1) {
      setIsAssign(true)()
    } else {
      onSaveTemplate()
    }
  }

  return (
    <>
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        height="s64"
        paddingY="s16"
        paddingX="s24"
        border={{
          bottom: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        <Text size="200" weight="semibold" color="grey800">
          {reportStruct.title.toUpperCase()}
        </Text>

        <Box paddingLeft="s12">
          <OptionsButton
            slug={reportStruct.templateSlug}
            onAddTemplate={onAddTemplate}
            loading={loading}
            reportStruct={reportStruct}
          />
        </Box>
      </Box>
      {isAssignOpen && (
        <AssignDashboardModal
          store={store}
          onSave={onSaveTemplate}
          onClose={setIsAssign(false)}
          loading={loading}
        />
      )}
    </>
  )
}
